import React from 'react';
import ServicesPageContent from '../sections/ServicesPageContent';

interface ServicesPageProps {
  onBookConsultation?: () => void;
}

export const ServicesPage: React.FC<ServicesPageProps> = () => {
  return (
    <main style={{ paddingTop: '80px' }}>
      <ServicesPageContent preview={false} />
    </main>
  );
};

export default ServicesPage;

